export const LOCKS_SYS_NAMES = {
    APERIO: "APERIO",
    EL_LOCKS_ENTRY: "EL_LOCKS_ENTRY",
    EL_LOCKS_EXIT: "EL_LOCKS_EXIT"
}